import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getProgressionLastElement(start, end, step) {
  var tmp;
  if (step > 0) {
    tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
  } else if (step < 0) {
    tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
  } else {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Step is zero.');
  }
  return tmp;
}
function differenceModulo(a, b, c) {
  return mod(mod(a, c) - mod(b, c) | 0, c);
}
function mod(a, b) {
  var mod = a % b | 0;
  return mod >= 0 ? mod : mod + b | 0;
}
//region block: exports
export {
  getProgressionLastElement as getProgressionLastElement2w30kdy2w5nkt,
};
//endregion

//# sourceMappingURL=progressionUtil.mjs.map
